import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconMemberTag({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M8.206 14C4.616 14 2 11.872 2 8.01v-.006C2 4.444 4.506 2 8.088 2 11.508 2 14 4.114 14 7.493V7.5c0 2.38-1.061 3.624-2.432 3.624-.93 0-1.541-.575-1.784-1.294l-.022-.065h-.067c-.346.87-1.105 1.294-2.049 1.294-1.533 0-2.565-1.222-2.565-3.041v-.007c0-1.762 1.054-2.977 2.565-2.977.789 0 1.504.403 1.784 1.014h.059V5.17h1.113v3.501c0 .992.398 1.474.98 1.474.774 0 1.305-.884 1.305-2.639V7.5c0-2.782-1.983-4.522-4.894-4.522-2.83 0-4.88 2.078-4.88 5.033v.007c0 3.228 2.19 4.997 5.108 4.997.988 0 1.998-.137 2.477-.345v.978c-.649.223-1.54.352-2.492.352zm-.39-3.954c1.01 0 1.658-.784 1.658-2.014v-.007c0-1.23-.648-1.999-1.644-1.999-.987 0-1.57.74-1.57 1.992v.007c0 1.258.59 2.02 1.556 2.02z"/>
        </svg>
    );
}

export default IconMemberTag;
